import React from "react";
import "./text-area.css";

const TextAreaField = ({
	field,
	value,
	onChange,
	className
}) => {
	const currentLength = String(value || "").length;
	const maxLength = field.maxLength;

	const handleChange = event => {
		const rawValue = event.target.value;

		const finalValue = field.onChange
			? field.onChange(rawValue)
			: rawValue;

		onChange(field.name, finalValue);
	};

	return (
		<div
			className="crm-input form-generic__textarea-field"
			style={{ width: "100%" }}
		>
			<label
				className="crm-input-label"
				htmlFor={field.name}
			>
				{field.label}
			</label>

			{maxLength && (
				<span className="form-generic__textarea-counter">
					{currentLength} / {Number(maxLength).toLocaleString("pt-BR")}
				</span>
			)}

			<textarea
				id={field.name}
				name={field.name}
				value={value ?? ""}
				placeholder={field.placeholder}
				onChange={handleChange}
				disabled={field.disabled}
				rows={field.rows || 5}
				maxLength={maxLength}
				className={className}
			/>
		</div>
	);
};

export default TextAreaField;